import React from "react"
import './Popup.css'

const Popup = ({record, visible, x, y, onDelete, onRestore, onMove, onDownload, intl}) => visible &&
  <ul className="popup" style={{position: "absolute", left: `${x}px`, top: `${y}px`}}>
    <li onClick={onDelete}>
        <img src="/images/icons/delete-asset-icon.svg" alt="delete icon" style = {{marginRight: 10, fill: "black"}}/>
        {intl.formatMessage({id: "trash-option-delete"})}
    </li>
    <li onClick={onRestore}>
        <img src="/images/icons/restore-asset-icon.svg" alt="restore icon" style = {{marginRight: 10, fill: "black"}}/>
        {intl.formatMessage({id: "trash-option-restore"})}
    </li>
    <li onClick={onMove}>
        <img src="/images/icons/move-asset-icon.svg" alt="move icon" style = {{marginRight: 10, fill: "black"}}/>
        {intl.formatMessage({id: "trash-option-move"})}
    </li>
    <li onClick={onDownload}>
        <img src="/images/icons/download-asset-icon.svg" alt="download icon" style = {{marginRight: 10, fill: "black"}}/>
        {intl.formatMessage({id: "trash-option-download"})}
    </li>
  </ul>

export default Popup